// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JrK1","rootNoMargin":"styles_rootNoMargin__2DHG-"};